// Dependencies
// -----------------------------------------------
import React from 'react';
import styled from 'styled-components';

// Theme tokens
// -----------------------------------------------
const C = {
  primary: 'var(--primary-cta-color, #20c778)',
  text: 'var(--base-color-text, #525860)',
  heading: 'var(--base-color-black, #040d18)',
  border: 'var(--base-color-border, #dbe1f4)',
  danger: '#ff1654'
};

// Styles
// -----------------------------------------------
const Card = styled.div`
  background: #fff;
  border: 1px solid ${C.border};
  border-radius: 20px;
  box-shadow: 0 24px 48px -24px rgba(4, 13, 24, 0.16);
  padding: 56px 40px;
  text-align: center;

  @media (max-width: 600px) {
    padding: 40px 20px;
    border-radius: 16px;
  }
`;

const IconCircle = styled.div`
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props =>
    props.$error
      ? 'rgba(255, 22, 84, 0.1)'
      : 'color-mix(in srgb, var(--primary-cta-color, #20c778) 12%, transparent)'};

  svg {
    width: 30px;
    height: 30px;
    fill: ${props => (props.$error ? C.danger : C.primary)};
  }
`;

const Headline = styled.h1`
  color: ${C.heading};
  font-size: 26px;
  font-weight: 700;
  margin: 0 0 10px;
`;

const Body = styled.p`
  color: ${C.text};
  font-size: 16px;
  line-height: 1.55;
  max-width: 440px;
  margin: 0 auto;
`;

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
  </svg>
);

const AlertIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
  </svg>
);

// -----------------------------------------------
// COMPONENT->MESSAGE ----------------------------
// -----------------------------------------------
const Message = props => {
  if (props.error) {
    return (
      <Card>
        <IconCircle $error>
          <AlertIcon />
        </IconCircle>
        <Headline>We couldn&apos;t find that booking</Headline>
        <Body>
          Sorry, we don&apos;t recognize your booking code. Please double-check
          the link in your email and try again.
        </Body>
      </Card>
    );
  }

  return (
    <Card>
      <IconCircle>
        <CheckIcon />
      </IconCircle>
      <Headline>Thank you for your review!</Headline>
      <Body>
        We appreciate you taking the time to share your feedback. We hope you
        choose to stay with us again soon.
      </Body>
    </Card>
  );
};

// Export
// -----------------------------------------------
export default Message;
